import { forwardRef, createElement } from 'react';

function IconUnreconciled(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M3.368 4.346l.092.062 18 14a.75.75 0 01-.828 1.246l-.092-.062-3.34-2.597L17 17h-2.5a.75.75 0 01-.102-1.493l.102-.007h.778l-3.536-2.75H7a.75.75 0 110-1.5h2.814l-3.46-2.69a3.501 3.501 0 00.454 6.935L7 15.5h2.5a.75.75 0 01.102 1.493L9.5 17H7a5 5 0 01-2.074-9.55L2.54 5.591a.75.75 0 01.828-1.246zM17 7a5 5 0 013.39 8.676l-1.208-.94a3.5 3.5 0 00-1.99-6.231L17 8.5h-2.5a.75.75 0 01-.102-1.493L14.5 7H17zm0 4.25a.75.75 0 110 1.5h-.372l-1.929-1.5H17z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Unreconciled = /*#__PURE__*/forwardRef(IconUnreconciled);

export default Unreconciled;
//# sourceMappingURL=Unreconciled.js.map
